import { render, staticRenderFns } from "./HealthUpdate.vue?vue&type=template&id=3217a1f0&scoped=true&"
import script from "./HealthUpdate.vue?vue&type=script&lang=js&"
export * from "./HealthUpdate.vue?vue&type=script&lang=js&"
import style0 from "./HealthUpdate.vue?vue&type=style&index=0&id=3217a1f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3217a1f0",
  null
  
)

component.options.__file = "HealthUpdate.vue"
export default component.exports